module.exports = __webpack_public_path__ + "img/Taylors_Bell_Foundry_0233.5090d758.jpg";